module.exports = __webpack_public_path__ + "c836f86a93305b1c1cd0af1f9948d2ee.pdf";